import React from "react";
import { IconButton, Tooltip, Box, Stack } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

/**
 * Column definitions for the Vehicle Trims data grid.
 *
 * @param {Object}   options
 * @param {Function} options.onEdit   - (row) => void
 * @param {Function} options.onDelete - (row) => void
 */
export const getVehicleTrimDataColumns = ({
  onEdit = () => { },
  onDelete = () => { },
} = {}) => [
    {
      field: "name",
      headerName: "Trim Name",
      width: 180,
      renderCell: (params) => (
        <span style={{ fontWeight: 500 }}>
          {params.value}
        </span>
      ),
    },
    {
      field: "engine",
      headerName: "Engine",
      sortable: true,
      filterable: false,
      flex: 1,
      minWidth: 200,
      renderCell: (params) => params.value || "—",
    },
    {
      field: "transmission",
      headerName: "Transmission",
      sortable: true,
      filterable: false,
      flex: 1,
      minWidth: 200,
      renderCell: (params) => params.value || "—",
    },
    {
      field: "drivetrain",
      headerName: "Drivetrain",
      sortable: true,
      filterable: false,
      flex: 1,
      minWidth: 200,
      renderCell: (params) => params.value || "—",
    },
    {
      field: "createdAt",
      headerName: "Created Date",
      width: 180,
      renderCell: (params) => {
        if (!params.value) return "—";
        const date = new Date(params.value);
        return (
          <span>
            {date.toLocaleDateString("en-US", {
              day: "2-digit",
              month: "short",
              year: "numeric",
            })}
            <br />
            <span style={{ color: "#888", fontSize: "0.75rem" }}>
              {date.toLocaleTimeString("en-US", {
                hour: "2-digit",
                minute: "2-digit",
              })}
            </span>
          </span>
        );
      },
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 120,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <Box sx={{ display: "flex", gap: 0.5, marginTop: 1.2 }}>
          <Tooltip title="Edit">
            <IconButton
              size="small"
              color="primary"
              onClick={(e) => {
                e.stopPropagation();
                onEdit(params.row);
              }}
            >
              <EditIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Delete">
            <IconButton
              size="small"
              color="error"
              onClick={(e) => {
                e.stopPropagation();
                onDelete(params.row);
              }}
            >
              <DeleteIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Box>
      ),
    },
  ];
